import { render, staticRenderFns } from "./LabelForm.vue?vue&type=template&id=5f408a14&scoped=true&"
import script from "./LabelForm.vue?vue&type=script&lang=js&"
export * from "./LabelForm.vue?vue&type=script&lang=js&"
import style0 from "./LabelForm.vue?vue&type=style&index=0&id=5f408a14&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f408a14",
  null
  
)

export default component.exports